import { boundActionsFactory } from 'shared/hooks/useBoundActions';
import { trackPlacementSend } from 'shared/store/analytics/actions/trackPlacementSend';

export const useCoworkingPlacementApplicationModalBoundActions = boundActionsFactory({
  trackPlacementSend,
});
